module.exports = __webpack_public_path__ + "img/empty.c2c5b245.svg";